import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo_relison(1).jpg";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <div className="navbar-container">

    <div className="navbar-inner">

        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="Relison Pharma" />
                <span className="company-name">RELISON PHARMA</span>

          </Link>
        </div>

        {/* Menu */}
        <nav className="navbar-menu">
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/products">Products</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>
 </div>
      </div>
    </header>
  );
};

export default Navbar;
